<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\score_static_new_1.png" alt="" /></div>
                <div>
                    <p>①.メインツールバーの【学習状況】アイコンをクリックし、【成績状況】メニューを選択し、「修了試験成績状況」画面が表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\courseConditionsManual-5.png" alt="" /></div>
                <div>
                    <p>※【修了コースも含む】はオフの場合は、終了したコース（学習修了を申請したコース）が含まれていません。</p>
                    <p>修了試験情報：</p>
                    <p>&nbsp;&nbsp;得点：受講者の最後の試験のスコア（何回でも試験を受けることができるが、最終回の試験の成績を得点とする）</p>
                    <p>&nbsp;&nbsp;平均点：試験に参加しているすべての受講者の平均得点</p>
                    <p>&nbsp;&nbsp;最高点：受講者中の最高得点</p>
                    <p>&nbsp;&nbsp;最低点：受講者中の最低得点</p>
                    <p>&nbsp;&nbsp;合格基準点：合格判定の基準得点</p>
                    <p>&nbsp;&nbsp;合格判定：合格・不合格で表記</p>
                    <p>&nbsp;&nbsp;合格/不合格詳細：合格/不合格人数の内訳（人数・率）</p>
                </div>

                <div><img src="/static\images\ja\newManual\courseConditionsManual-6.png" alt="" /></div>
                <div>
                    <p>②.一覧に表示されている現在の得点、及び合格/不合格の判定は、受講者の最終回の試験結果にて基いて行います。</p>
                    <p>&nbsp;&nbsp;【受験履歴】列の【表示】ボタンをクリックすると、今まで受けた全ての試験の履歴が表示されます。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p><b>❖【学習状況】の【成績状況】をクリックすると、「修了試験成績状況」画面が表示されます。</b></p></div>
                <div><img src="/static\images\ja\newManual\mobile\score_static_mb_new_1.png" alt="" /></div>
                <div><p>①.コースを検索したい場合に検索ボックスにコース名称を入力し、「検索」ボタンを押下してください。</p></div>
                <div><p>②.【修了コースも含む】はオフの場合は、終了したコース（学習修了を申請したコース）が含まれていません。</p></div>
                <div><p>③.試験を受けたコースの一覧は表示されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\score_static_mb_new_2.png" alt="" /></div>
                <div><p>④.コースを選択すると、「受講者数」、「得点」、「平均点」、「最高点」、「最低点」、「合格基準点」、「合格判定」、「受験履歴」、及び「合格／不合格詳細」などを表示する「修了試験成績状況」画面に遷移します。</p></div>
                <div><p>● 得点：受講者の最後の試験のスコア（何回でも試験を受けることができるが、最終回の試験の成績を得点とする）</p></div>
                <div><p>● 平均点：試験に参加しているすべての学習者の平均得点</p></div>
                <div><p>● 最高点：受講者中の最高得点</p></div>
                <div><p>● 最低点：受講者中の最低得点</p></div>
                <div><p>● 合格基準点：合格するため最低の得点</p></div>
                <div><p>● 合格判定：合格・不合格が表示する</p></div>
                <div><p>● 合格/不合格詳細：合格/不合格人数の内訳（人数・率）</p></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/scoreStatistics_manual.vue